import Select from 'react-select';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useGetPersons from '../../../hooks/HR/use-get-persons';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from '../../../components/card/card';
import Loading from '../../../components/Shared/Loader/Loading';
import useGetFormColumn from '@hooks/Forms/use-get-FColumn';

const DriverForm = ({ formik }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { dataEmployees, loading: personLoading } = useGetPersons();

  // console.log(formik);

  // const { FormColumnList, loading, error } = useGetFormColumn(FormId);
  const { FormColumnList, loading, error } = useGetFormColumn('04ba71f9-c9b7-4e99-8a03-306a923b3cf0');

  // console.log(FormColumnList);

  return (
    <Loading>
      <Form onSubmit={formik.handleSubmit}>
        <div className='mb-4'>
          <h5>
            <i className='bi bi-info-circle fa-lg  text-theme'></i> Basic Information
          </h5>
          <hr />

          <CardBody>
            <div className='row'>
              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('LocalName')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='name2'
                    onChange={formik.handleChange}
                    value={formik.values.name2}
                    isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                </div>
              </div>

              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('GlobalName')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='name'
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    isInvalid={!!(formik.touched.name && formik.errors.name)}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                </div>
              </div>

              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('EmployeeName')}</label>
                  <Select
                    classNamePrefix='react-select'
                    isLoading={personLoading}
                    isSearchable={true}
                    isClearable
                    name='personId'
                    options={dataEmployees}
                    onChange={option => {
                      formik.setFieldValue('personId', option === null ? null : option.value);
                    }}
                    value={
                      formik.values.personId
                        ? dataEmployees?.find(option => option.value === formik.values.personId)
                        : null
                    }
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />

                  {formik.errors.personId && formik.touched.personId && (
                    <div style={{ color: 'red' }}>{formik.errors.personId}</div>
                  )}
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Email')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='email'
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    isInvalid={!!(formik.touched.email && formik.errors.email)}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('MobileNumber')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='mobile'
                    onChange={formik.handleChange}
                    value={formik.values.mobile}
                    isInvalid={!!(formik.touched.mobile && formik.errors.mobile)}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.mobile}</Form.Control.Feedback>
                </div>
              </div>

              <div className='col-xl-6'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Address')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='address'
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    isInvalid={!!(formik.touched.address && formik.errors.address)}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.address}</Form.Control.Feedback>
                </div>
              </div>
            </div>
          </CardBody>
        </div>

        <div className='mb-4'>
          <h5>
            <i className='bi bi-card-heading fa-lg  text-theme'></i> Driving License
          </h5>
          <hr />

          <CardBody>
            <div className='row'>
              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('رقم الرخصة')}</label>
                  <Form.Control className='form-control' type='text' autoComplete='off' />
                </div>
              </div>

              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('تاريخ الإنتهاء')}</label>
                  <Form.Control className='form-control' type='date' autoComplete='off' />
                </div>
              </div>

              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('نوع الرخصة')}</label>
                  <Select
                    classNamePrefix='react-select'
                    isLoading={personLoading}
                    isSearchable={true}
                    isClearable
                    options={[
                      {
                        value: '1',
                        label: 'رخصة قيادة خصوصي'
                      },
                      {
                        value: '2',
                        label: 'رخصة قيادة عمومي'
                      },
                      {
                        value: '3',
                        label: 'رخصة قيادة المعدات الثقيلة والآليات'
                      }
                    ]}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>
              </div>
            </div>
          </CardBody>


        </div>

        <div className='text-center'>
          <div className='d-flex justify-content-between gap-2'>
            <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-save fa-lg fa-fw me-2'></i>
              )}
              {t('Save')}
            </button>
            <button
              type='button'
              className='btn btn-lg  btn-default mb-1 w-100'
              data-bs-dismiss='modal'
              id='closeModalPosition'
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </Loading>
  );
};

export default DriverForm;
